import dynamic from "next/dynamic";
import BaseFooterConfig from "./base-footer-config";
import BaseFooterAdvancedConfig from "./base-footer-advanced-config";
const BaseFooterComponent = dynamic(()=>import("./base-footer-component"));
export default {
    BaseFooterComponent,
    BaseFooterConfig,
    BaseFooterAdvancedConfig
};
